module.exports = __webpack_public_path__ + "img/icon-github-dark.6a9b1969.svg";